import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../../common/html/button'
import { Icon } from '../../../../common/html/icon'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { CHECKBOX_KEYS } from '../constants'
import { getFilterLocationTypeOptions } from '../helpers'
import classes from '../index.module.scss'
import {
  changeCheckedOptions,
  resetCheckedOptions,
  selectCheckedOptions,
  selectCountData,
  selectFilter,
} from '../store/slice'
import { postDomesticSearchCount } from '../store/thunk'
import { SearchFilterListCheckbox } from './SearchFilterListCheckbox'

export const SearchFilter = ({ textSearch }) => {
  const dispatch = useDispatch()

  const checkedOptions = useSelector(selectCheckedOptions)
  const countData = useSelector(selectCountData)
  const filter = useSelector(selectFilter)

  const onCheckboxChange = (data) => {
    dispatch(changeCheckedOptions(data))
  }

  const onResetDefault = () => {
    dispatch(resetCheckedOptions())
  }

  useEffect(() => {
    const statusIds = Object.keys(checkedOptions)
      .filter(
        (key) => key.includes(CHECKBOX_KEYS.STATUS) && checkedOptions[key],
      )
      .map((key) => +key.split('-')[1])
    const legalFormIds = Object.keys(checkedOptions)
      .filter(
        (key) => key.includes(CHECKBOX_KEYS.LEGAL_FORM) && checkedOptions[key],
      )
      .map((key) => +key.split('-')[1])
    const headQuarters = Object.keys(checkedOptions)
      .filter(
        (key) =>
          key.includes(CHECKBOX_KEYS.LOCATION_TYPE) && checkedOptions[key],
      )
      .map((key) => +key.split('-')[1])

    dispatch(
      postDomesticSearchCount({
        term: textSearch,
        statusIds: statusIds.length ? statusIds : undefined,
        legalFormIds: legalFormIds.length ? legalFormIds : undefined,
        headQuarters: headQuarters.length ? headQuarters : undefined,
      }),
    )
  }, [textSearch, checkedOptions])

  const renderTopComponent = () => {
    return (
      <div className={classes.buttonResetContainer}>
        <Button
          label={
            <span className="dFlex alignItemsCenter justifyContentCenter">
              <Icon className="icon-reset" />
              &nbsp;
              <Translate value="domesticSearch.RESET" />
            </span>
          }
          style={{ color: '#fff', backgroundColor: '#0553A5' }}
          className={['mb2 w100 cursorPointer', classes.buttonReset].join(' ')}
          action={onResetDefault}
        />
      </div>
    )
  }

  return (
    <div className="flexColumn h100">
      {renderTopComponent()}
      <div className="positionRelative flex1">
        <ScrollComponent>
          <div className={classes.searchFilterContent}>
            <SearchFilterListCheckbox
              title="domesticSearch.STATUS"
              data={countData}
              options={filter.activeStatus}
              checked={checkedOptions}
              onChange={onCheckboxChange}
            />
            <div className={classes.dividerFilter} />
            <SearchFilterListCheckbox
              isI18n
              title="domesticSearch.LOCATION_TYPE"
              data={countData}
              options={getFilterLocationTypeOptions()}
              checked={checkedOptions}
              onChange={onCheckboxChange}
            />
            <div className={classes.dividerFilter} />
            <SearchFilterListCheckbox
              title="domesticSearch.LEGAL_FORM"
              data={countData}
              options={filter.legalForm}
              checked={checkedOptions}
              onChange={onCheckboxChange}
            />
          </div>
        </ScrollComponent>
      </div>
    </div>
  )
}
